import { cn } from '@dfh-corp-sites/ui/utils'
import { GatsbyImage, withArtDirection } from 'gatsby-plugin-image'
import React, { useMemo } from 'react'

import { SanityAcademicInstitutions } from '../../../graphql/gatsby'
import { getGatsbyImageDataForAsset } from '../../../utils/sanity/image'

export const AcademicInstitutions: React.FC<SanityAcademicInstitutions> = ({
  academicTitle,
  links,
  sideImage,
  tagName,
  academicContent,
}) => {
  const images = useMemo(() => {
    return links?.map((item) => {
      const imageData = getGatsbyImageDataForAsset(item?.image, {})

      const currentImages = imageData
        ? withArtDirection(imageData, [
            {
              image: imageData,
              media: '',
            },
          ])
        : imageData

      return currentImages
    })
  }, [links])

  const sideImageComponent = useMemo(() => {
    return getGatsbyImageDataForAsset(sideImage, {})
  }, [sideImage])

  return (
    <div
      className={cn([
        'w-full bg-white',
        'flex pt-16 my-10',
        'border-l-8 border-l-brand-red',
        'items-stretch',
      ])}
    >
      <div className={cn(['w-full flex flex-col justify-between', 'lg:w-[60%]'])}>
        <div className={cn(['px-6', 'md:px-16'])}>
          <div className="h-[1px] w-full bg-brand-navy mb-8" />

          <span className="text-brand-navy text-sm font-normal uppercase">{tagName}</span>

          <h2
            className={cn([
              'text-brand-navy text-[32px] leading-[120%] font-medium mt-6',
              'md:text-[40px]',
            ])}
          >
            {academicTitle}
          </h2>

          <p className="whitespace-pre-line mt-5 text-xl text-brand-navy leading-[150%] font-normal">
            {academicContent}
          </p>
        </div>

        <div className="grid grid-cols-1 mt-8 md:grid-cols-3 border-t border-rule-grey">
          {images?.map(
            (imgData, index: number) =>
              imgData && (
                <div
                  key={links?.[index]?._key}
                  className={cn([
                    'p-4 border-r border-b border-rule-grey',
                    'flex items-center justify-center',
                  ])}
                >
                  <GatsbyImage
                    image={imgData}
                    alt="Institutions"
                    loading="eager"
                    className="max-w-[260px]"
                  />
                </div>
              ),
          )}
        </div>
      </div>

      <div className={cn(['w-[40%] hidden', 'lg:block relative  h-auto'])}>
        {sideImageComponent && (
          <GatsbyImage
            className="w-full h-full object-cover"
            image={sideImageComponent}
            alt=""
            loading="eager"
          />
        )}
      </div>
    </div>
  )
}
